<button [class.filter-active]="selected.length > 0" [matMenuTriggerFor]="statusFilter" class="small-icon-button"
        mat-icon-button>
  <mat-icon *ngIf="selected.length === 0">filter_list</mat-icon>
  <mat-icon *ngIf="selected.length > 0">filter_alt</mat-icon>
</button>
<mat-menu #statusFilter="matMenu" [class]="'check-box-filter-menu columns-' + columns">
  <div class="check-box-columns">
    @for (o of options; track o.value) {
      <div (click)="checkboxChanged(o.value); $event.stopPropagation()"
           (keydown.enter)="checkboxChanged(o.value); $event.stopPropagation()"
           (keydown.space)="checkboxChanged(o.value); $event.stopPropagation()"
           class="check-box-filter" mat-menu-item>
        <mat-checkbox [checked]="selected.includes(o.value)">
          <div class="two-lines">
            @if (user) {
              <app-user [email]="o.value"></app-user>
            } @else {
              {{ o.display }}
            }
          </div>
        </mat-checkbox>
      </div>
    }
  </div>
  <button (click)="clear()"
          [disabled]="selected.length === 0"
          mat-menu-item>
    <mat-icon>filter_alt_off</mat-icon>
    <span>Clear filter</span>
  </button>
</mat-menu>
